import React from "react";
import ReactDOM from "react-dom/client";
import "./globalStyles";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

// GitHub Pages has no SPA fallback: a deep link like /admin/conferences hits
// public/404.html, which saves the path and loads "/". Put that path back
// before the router reads the URL.
const saved = sessionStorage.getItem("spa-redirect");
if (saved) {
  sessionStorage.removeItem("spa-redirect");
  window.history.replaceState(null, "", saved);
}

// Old hash links (/#/donate) from before the switch to clean URLs
if (window.location.hash.startsWith("#/")) {
  window.history.replaceState(null, "", window.location.hash.slice(1));
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
